import { ValidationInputType } from "@cak-legacy/generation-core";

import { AbstractValidation } from "./AbstractValidation";
import { isFileManagementField } from "./isFileManagementField";
import { CustomErrorMessage } from "./ValidationHelper";
import { translate } from "../Locales/translator";

export class HasMinFilesUploadValidation extends AbstractValidation {
  key = "hasMinFileUpload";
  constructor(private readonly minFiles: number, customErrorMessage?: CustomErrorMessage) {
    super(customErrorMessage);
  }

  validate = (value: ValidationInputType) => {
    if (!value) {
      return false;
    }

    const valueAsAny = value as any;
    const filesCount = isFileManagementField(valueAsAny)
      ? valueAsAny.files.filter((file) => !file.deleted).length
      : Array.from(value as FileList).length;

    return filesCount >= this.minFiles;
  };

  defaultMessage = (label: string): string =>
    translate("Generation_Form_{label}MoetMinimaal{minFiles}BijlagenZijn", {
      label,
      minFiles: this.minFiles.toString()
    });
}
